module.exports = __webpack_public_path__ + "img/ch07_06_地铁车厢.4142a9cc.jpg";